import "core-js/modules/es.array.find-index";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import appidPup from "../../auth/roles/components/appidPup";
import addCoach from "./components/addCoach.vue";
import addUser from "./components/addUser";
export default {
  name: "users",
  components: {
    addUser: addUser,
    appidPup: appidPup,
    addCoach: addCoach
  },
  data: function data() {
    return {
      paramsData: {
        page: 1
      },
      tableData: [],
      total: 0
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _arguments = arguments,
          _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var page;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                page = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : 1;
                _this.paramsData.page = page;

                _this.$api.userList(_this.paramsData).then(function (res) {
                  if (res.status == 200) {
                    if (page > 1 && !res.data.data.length) {
                      _this.getList(page - 1);
                    } else {
                      _this.tableData = res.data.data;
                      _this.total = res.data.total;
                    }
                  }
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleDisable: function handleDisable(id) {
      var _this2 = this;

      var index = this.tableData.findIndex(function (i) {
        return i.id == id;
      });
      this.$api.disableUser({
        id: id
      }).then(function (res) {
        if (res.status == 200) {
          _this2.tableData[index].status = _this2.tableData[index].status == 0 ? 1 : 0;

          _this2.$message.success('修改成功');
        } else {
          _this2.$message.err('修改失败');
        }
      });
    },
    handleDelete: function handleDelete(id) {
      var _this3 = this;

      this.$confirm("此操作将删除该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.$api.delUser({
                  id: id
                });

              case 2:
                _this3.getList(_this3.paramsData.page);

                _this3.$message({
                  type: "success",
                  message: "删除成功!"
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    }
  }
};